import axios from "src/lib/axios";
import { getParams } from "src/common/api";

/**
 *
 * @param {number} days
 * @param {YYYY-MM-DD} startDate
 * @param {YYYY-MM-DD} endDate
 * @param {YYYY-MM-DD} compareStart
 * @param {YYYY-MM-DD} compareEnd
 * @param {string} sellerId
 * @description Get all summary data for the dashboard, based on the specified time range and seller ID.
 * @returns
 */
export const getAllSummary = async (params) => {
  const {
    days = 28,
    startDate = "",
    endDate = "",
    compareStart = "",
    compareEnd = "",
    sellerId = "",
  } = params;
  const queryParams = getParams({
    days,
    startDate,
    endDate,
    compareStart,
    compareEnd,
    sellerId,
  });
  const { data: response } = await axios.get(
    `/analytics/sku/all?${queryParams}`,
  );
  return response.data;
};

export const getKpiSummary = async (params) => {
  const { days = 28, startDate = "", endDate = "", sellerId = "" } = params;
  const queryParams = getParams({
    days,
    startDate,
    endDate,
    sellerId,
  });
  const { data: response } = await axios.get(
    `/analytics/sku/summary?${queryParams}`,
  );
  return response.data;
};

export const getdailyViews = async (params) => {
  const {
    days = 28,
    startDate = "",
    endDate = "",
    compareStart = "",
    compareEnd = "",
  } = params;
  const queryParams = getParams({
    days,
    startDate,
    endDate,
    compareStart,
    compareEnd,
  });
  const { data: response } = await axios.get(
    `/analytics/sku/daily-views?${queryParams}`,
  );
  return response.data;
};

export const getTopSkus = async (params) => {
  const {
    days = 28,
    limit = 25,
    startDate = "",
    endDate = "",
    compareStart = "",
    compareEnd = "",
    sellerId = "",
  } = params;
  const queryParams = getParams({
    days,
    limit,
    startDate,
    endDate,
    compareStart,
    compareEnd,
    sellerId,
  });
  const { data: response } = await axios.get(
    `/analytics/sku/top-skus?${queryParams}`,
  );
  return response.data;
};

export const getCategoryShare = async (params) => {
  const {
    days = 28,
    startDate = "",
    endDate = "",
    compareStart = "",
    compareEnd = "",
  } = params;
  const queryParams = getParams({
    days,
    startDate,
    endDate,
    compareStart,
    compareEnd,
  });
  const { data: response } = await axios.get(
    `/analytics/sku/category-share?${queryParams}`,
  );
  return response.data;
};

export const getSearchTerms = async (params) => {
  const {
    days = 28,
    startDate = "",
    endDate = "",
    compareStart = "",
    compareEnd = "",
  } = params;
  const queryParams = getParams({
    days,
    startDate,
    endDate,
    compareStart,
    compareEnd,
  });
  const { data: response } = await axios.get(
    `/analytics/sku/search-terms?${queryParams}`,
  );
  return response.data;
};

export const getProductTrends = async (params) => {
  const {
    days = 28,
    startDate = "",
    endDate = "",
    compareStart = "",
    compareEnd = "",
    sellerId = "",
  } = params;
  const queryParams = getParams({
    days,
    startDate,
    endDate,
    compareStart,
    compareEnd,
    sellerId,
  });
  const { data: response } = await axios.get(
    `/analytics/sku/product-trends?${queryParams}`,
  );
  return response.data;
};

export const getFeatureEventsByAdmin = async (params) => {
  const {
    days = 28,
    startDate = "",
    endDate = "",
    compareStart = "",
    compareEnd = "",
    sellerId = "",
  } = params;
  const queryParams = getParams({
    days,
    startDate,
    endDate,
    compareStart,
    compareEnd,
    sellerId,
  });
  const { data: response } = await axios.get(
    `/analytics/sku/feature-events?${queryParams}`,
  );
  return response.data;
};
